import { ReactComponent as CloseSvg } from '../../assets/icons/close.svg';

export default function CloseIcon() {
  return <CloseSvg aria-hidden="true" focusable="false" />;
}
